import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import "react-toastify/dist/ReactToastify.css";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
const ExpenseView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
 
  const [valuepayment, setValuepayment] = useState([]);
     const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");

  const [currencySymbol, setCurrencySymbol] = useState('');
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

 const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];
  useEffect(() => {
        setPermission(FindModuleById(271)); 
console.log(permission);

    raw_data_invoice ='';

    axios
      .get(`/expenses/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.expense);
          axios.get(`/expenses/view-payments/${season_id+'-'+id}`, {
           headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
         })
         .then((response) => {
           if (response.data.code === 200) {
            console.log(response.data.data.payments);
            setValuepayment(response.data.data.payments);
           
           }
         })
         .catch((error) => {
           console.log(error);
         });


         setValue(response.data.data.expense);
         const currencydetail = primaryCurrency.find(item => item.value === response.data.data.expense.currency) || null;
        setCurrencySymbol(currencydetail ? currencydetail.symbol : 'dh');
      
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
  }, [id]);


  let raw_data_invoice ='';
  if(value.invoice_attachment){
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: value.invoice_attachment};
    raw_data_invoice = s3.getSignedUrl('getObject', params);
  
  }
  
  console.log(valuepayment);


 
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Expense</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/expenses">Expenses</Link>
                    </li>
                    <li className="breadcrumb-item active">View</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
            {permission?.list == 1 && (
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Expense Information</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Type</th>
                        <td className="p-3">{(value.type ==2) ?'Credit Note Number':'Invoice Number'}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Invoice Number</th>
                        <td className="p-3">{value.invoice_number}</td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Invoice Date</th>
                        <td className="p-3">{value.invoice_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Invoice Due Date</th>
                        <td className="p-3">{value.invoice_due_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Supplier&apos;s Name</th>
                        <td className="p-3">{value.supplier}</td>
                      </tr>
                       <tr>
                        <th className="p-3">IF</th>
                        <td className="p-3">{value.if}</td>
                      </tr>
                      <tr>
                        <th className="p-3">ICE</th>
                        <td className="p-3">{value.ice}</td>
                      </tr>
                  
                      <tr>
                        <th className="p-3">Amount HT</th>
                        <td className="p-3">{(value.type ==2) ?'-':'-'}{value.amount_ht}{currencySymbol}</td>
                      </tr>
                      
                      <tr>
                        <th className="p-3">Total Amount TTC</th>
                        <td className="p-3">{(value.type ==2) ?'-':'-'}{value.total_amount_ttc}{currencySymbol}</td>
                      </tr>
                     
                     
                      <tr>
                        <th className="p-3">Expense Type</th>
                        <td className="p-3">
                          {value.expense_type}
                        </td>
                      </tr>

                   
                      <tr>
                        <th className="p-3">Expense Type Extention</th>
                        <td className="p-3">{value.expense_type_extention}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Payment Method</th>
                        <td className="p-3">{value.payment_method}</td>
                      </tr>
                     
                      <tr>
                        <th className="p-3">Payment Status</th>
                        <td className="p-3">
                          {value.payment_status}
                        </td>
                      </tr>
                      {raw_data_invoice != '' && (
                          <tr>
                          <th className="p-3">Invoice Attachment</th>
                          <td className="p-3">
                            <a
                              className="btn btn-primary invoicebtn"
                              href={raw_data_invoice}
                              target="_blank"
                              download
                              rel="noreferrer" 
                            >
                              Download
                            </a>
                          </td>
                        </tr>
                      )}
                       <tr>
                        <th className="p-3">Payment Note</th>
                        <td className="p-3">{value.payment_note}</td>
                      </tr>
                    </table>

                      <br />
                      
                      <table className="table table-bordered">
                        <thead>
                        <tr>
                          <th className="p-3">TVA Rate</th>
                          <th className="p-3">TVA Amount</th>
                        </tr>

                        </thead>
                          <tbody>
                        {value.items &&
                          value.items.map((item, indx) => (
                            <tr  key={item.indx || indx}>
                              <td className="p-3">{item.tva_rate}%</td>
                              <td className="p-3">{(value.type ==2) ?'-':'-'}{item.tva_amount}</td>
                              
                            </tr>
                          ))}
                          </tbody>
                      </table>
                  </div>
                </div>
              </div>
            )}
          </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ExpenseView;
